import 'shared/bitmap-polyfill';

// @ts-expect-error
import hasOwn from 'object.hasown'; // Shim for Object.hasOwn() required by iOS 15

export const applyPolyfills = (): void => {
  if (!Object.hasOwn) {
    hasOwn.shim();
  }
};
